export default () : void => {
  if (localStorage.getItem('authToken')) localStorage.removeItem('authToken')
  if (sessionStorage.getItem('authToken')) sessionStorage.removeItem('authToken')
}
